import { SelectFieldDuration } from 'components/Global';
import SelectFieldDate from 'components/Global/SelectFieldDate';
import RentTimeComponents from 'components/HomeComponent/Content/CustomOrderCarCharterComponent/DetailSewa/RentTimeComponents';
import { addDays, format } from 'date-fns';

const DetailHari = ({
  startRentDate,
  setStartRentDate,
  durationRent,
  setDurationRent,
  selectedCar,
  setSelectedCar,
  allRentTime,
  setAllRentTime,
  orderData,
  setOrderData,
  setSelectedAdditionalItem,
  dayDuration,
  setDayDuration,
}) => {
  const changeStartDateHandler = (date) => {
    if (date) {
      setStartRentDate(date);
      setOrderData({
        ...orderData,
        order_detail: {
          ...orderData.order_detail,
          vehicle_id: '',
          start_booking_date: format(date, 'yyyy-MM-dd').toString(),
          end_booking_date: durationRent ? format(addDays(date, durationRent - 1), 'yyyy-MM-dd').toString() : '',
        },
      });
      setSelectedCar(undefined);
      setSelectedAdditionalItem(undefined);
    }
  };

  const durationRentDateHandler = (duration) => {
    setDurationRent(duration);
    setSelectedCar(undefined);
    setOrderData({
      ...orderData,
      order_detail: {
        ...orderData.order_detail,
        end_booking_date: format(addDays(startRentDate, duration), 'yyyy-MM-dd').toString(),
        vehicle_id: '',
      },
    });
    setSelectedAdditionalItem(undefined);

    if (dayDuration.length !== 0) {
      const copyDayDuration = [...dayDuration];
      const slicedCopyDayDuration = copyDayDuration.slice(0, duration);
      setDayDuration(slicedCopyDayDuration);
    }
  };

  return (
    <div className="edit-car-charter__content-data__detail-hari">
      <h2>Detail Hari</h2>
      <div className="edit-car-charter__content-data__detail-hari-form">
        <SelectFieldDate
          label="Tanggal Mulai"
          htmlFor="tanggal-mulai"
          name="tanggal-mulai"
          handleDaySelect={changeStartDateHandler}
          selectedDay={startRentDate}
          value={startRentDate !== '' ? format(startRentDate, 'dd-MM-yyyy') : startRentDate}
          placeholder="Pilih Tanggal"
        />

        <SelectFieldDuration
          label="Durasi Charter"
          htmlFor="durasi-charter"
          placeholder="0 Hari"
          startDate={startRentDate}
          value={durationRent}
          onClick={durationRentDateHandler}
        />

        <RentTimeComponents
          durationRent={durationRent}
          startDate={startRentDate}
          charterPricingData={selectedCar?.charter_pricing ?? []}
          allRentTime={allRentTime}
          setAllRentTime={setAllRentTime}
        />
      </div>
    </div>
  );
};

export default DetailHari;
